<template>
  <div>
    <div class="page-title">Edit Submission Visualization</div>
    <Form
      v-if="form"
      v-model="form"
      :submit="update"
      @destroy="destroy"
      action="edit"
      btnText="Update Submission Visualization"
    />
    <Spinner v-else />
  </div>
</template>

<script>
import Form from "./_form.submission-contents.page";
export default {
  components: { Form },
  data() {
    return {
      form: null,
    };
  },
  created() {
    this.setForm();
  },
  methods: {
    async destroy() {
      await this.$api.SubmissionContent.destroy({ id: this.$route.params.id });
      this.$router.push("/widgets/submission-forms");
    },
    async setForm() {
      const { data } = await this.$api.SubmissionContent.get({
        id: this.$route.params.id,
      });
      this.form = data;
    },
    async update() {
      await this.$api.SubmissionContent.update(this.form);
      this.$router.push("/widgets/submission-forms");
    },
  },
};
</script>

<style></style>
